import React, { useState } from "react";
import { Download, Presentation, Check } from "lucide-react";

export default function DemoAuditPresentationSection() {
  const [downloadSuccess, setDownloadSuccess] = useState(false);

  const handleDownload = () => {
    setDownloadSuccess(true);
    setTimeout(() => setDownloadSuccess(false), 4000);
  };

  return (
    <section id="demo-audit-report" className="max-w-6xl mx-auto px-3.5 sm:px-6 lg:px-8 py-8 sm:py-12 scroll-mt-24">
      <div className="bg-gradient-to-b from-[#0b0f19] via-[#090d16] to-[#070a12] border-2 border-cyan-500/35 rounded-2xl sm:rounded-3xl p-5 sm:p-8 md:p-10 relative overflow-hidden shadow-[0_0_40px_rgba(6,182,212,0.12)]">
        {/* Ambient Top Glow */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-3/4 h-24 bg-gradient-to-b from-cyan-500/15 via-blue-500/10 to-transparent blur-2xl pointer-events-none" />

        <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-6 relative z-10">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-cyan-500/10 border border-cyan-500/30 text-cyan-400 text-xs font-mono uppercase tracking-wider mb-3">
              <Presentation className="w-3.5 h-3.5 text-cyan-300" />
              <span>DEMO AUDIT • 22-SLIDE PRESENTATION</span>
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-white font-heading tracking-tight leading-tight">
              See How the Audit Report Looks{" "}
              <span className="bg-gradient-to-r from-cyan-400 via-sky-300 to-blue-400 bg-clip-text text-transparent">
                &amp; What It Solves
              </span>
            </h2>
            <p className="text-slate-300 text-sm sm:text-base mt-2 leading-relaxed">
              Want to inspect the exact deliverable before ordering? Download the full <strong className="text-white">22-Slide Demo Presentation Deck (PPT)</strong>.
            </p>
          </div>

          {/* Download Action Box */}
          <div className="shrink-0 flex flex-col sm:flex-row lg:flex-col items-stretch sm:items-center lg:items-end gap-2.5">
            <a
              href="/downloads/Demo-AI-Visibility-Audit-Report.pptx"
              download="Demo-AI-Visibility-Audit-Report.pptx"
              onClick={handleDownload}
              className="px-6 py-3.5 rounded-xl bg-gradient-to-r from-cyan-500 via-blue-600 to-indigo-600 hover:from-cyan-400 hover:to-indigo-500 text-white font-heading font-bold text-sm shadow-[0_0_25px_rgba(6,182,212,0.35)] hover:shadow-[0_0_35px_rgba(6,182,212,0.5)] transition-all duration-200 transform hover:-translate-y-0.5 flex items-center justify-center gap-2 group whitespace-nowrap cursor-pointer"
            >
              {downloadSuccess ? (
                <>
                  <Check className="w-4 h-4 text-emerald-300" />
                  <span>Downloading PPT...</span>
                </>
              ) : (
                <>
                  <Download className="w-4 h-4 group-hover:translate-y-0.5 transition-transform" />
                  <span>Download Demo Audit (PPT)</span>
                </>
              )}
            </a>
            <div className="flex items-center justify-center lg:justify-end gap-2 text-[11px] font-mono text-slate-400">
              <span>22 Slides • 16:9 PPTX</span>
              <span>•</span>
              <span className="text-emerald-400 font-semibold">Free Direct Download</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
